import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { BankOutlined } from '@ant-design/icons-vue'
import { useIdentityStore } from '@/stores/identity/auth'
import type { RouteRecordRaw } from 'vue-router'

export const org_routes: RouteRecordRaw[] = [
  {
    path: '/org/list',
    name: 'org-list',
    component: () => getComponent(`pages/org/org-list.vue`),
    meta: {
      title: () => 'Organizations',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Organizations',
        label: 'Organizations',
        icon: () => h(BankOutlined),
        path: `${prefix}/org/list`,
        condition: () => {
          const identity_store = useIdentityStore()
          return (
            identity_store.auth.user.roles.includes('org_admin') ||
            identity_store.auth.user.roles.includes('super_admin')
          )
        },
      },
    },
  },
  {
    path: '/org/:id(\\d+)+',
    name: 'org-details',
    component: () => getComponent(`pages/org/org-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Organization #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/org/new',
    name: 'org-new',
    component: () => getComponent(`pages/org/org-new.vue`),
    meta: {
      title: () => `New Organization`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/org/:id(\\d+)+/edit',
    name: 'org-edit',
    component: () => getComponent(`pages/org/org-edit.vue`),
    meta: {
      title: () => `Edit Organization`,
      layout: Layout,
      is_public: false,
    },
  },
]
